import { HttpClient } from '../HttpClient';
/**
 * * Get Approver status By Id
 */

export const GetApproverStatus = async (jobRequestId) => {
  try {
    const { data } = await HttpClient.get(`api/jobrequisitions/ApproversStatus?JobRequestId=${jobRequestId}`);
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
